<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <p>Produced by </p>
          </li>
          <li>
            <a :href="kongnpark.link" target="_blank">
              {{ kongnpark.label }}
            </a>
          </li>
          <li>
            <p> and </p>
          </li>
          <li>
            <a :href="corpuslab.link" target="_blank">
              {{ corpuslab.label }}
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a :href="copyrightInfo.link" target="_blank">{{ copyrightInfo.label }}</a>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    name: 'content-footer',
    data() {
      return {
        copyrightInfo: {
          label: "국제한국어응용언어학회",
          link: "https://www.iskal.org/",
        },
        kongnpark: {
          label: "Kong & Park Inc.",
          link: "https://www.kongnpark.com/",
        },
        corpuslab: {
          label: "Corpus Lab Inc.",
          link: "https://www.corpuslab.io/",
        },
      }
    }
  };
</script>
<style></style>
